// App.tsx
import React from "react";
import MainRoute from "../src/routes/routes"
import "@fontsource/poppins";
import "@fontsource/poppins/400.css"
import "@fontsource/poppins/600.css"
import "@fontsource/poppins/700.css"

//import 'bootstrap/scss/bootstrap.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/styles/index.css';
import "react-date-picker/dist/DatePicker.css";

function App() {
  return (
    <MainRoute></MainRoute>
  );
}

export default App;
